module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAABlBMVEX///8zptOUaBC2AAAAFUlEQVQI12MgGvBgIf4fgBKYskQDAPxPA9/9eNEkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_add2_hover.png
// module id = UCKn
// module chunks = 9